var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden",
        },
      ],
      staticClass: "input grid__cell",
      class: _vm.inputClasses,
    },
    [
      _c(
        "div",
        {
          staticClass: "input--text mg mg--b-2",
          class: [
            { "right-padding": _vm.removeIcon },
            { inputErr: _vm.$v.value.$error },
          ],
        },
        [
          _c(
            "p",
            {
              staticClass: "text-small-bold black mg mg--b-1",
              class: { inputIsFocused: _vm.inputHasFocus },
            },
            [_vm._v(_vm._s(_vm.$t(_vm.literal)))]
          ),
          _c("div", { staticClass: "input__wrapper" }, [
            _c("input", {
              staticClass: "inputTextNumber",
              attrs: {
                name: _vm.name,
                type: _vm.type,
                disabled: _vm.disabled,
                inputmode: "numeric",
                autocomplete: _vm.autocomplete,
                required: "",
              },
              domProps: { value: _vm.value },
              on: {
                change: function ($event) {
                  return _vm.$emit("change", $event.target.value)
                },
                input: function ($event) {
                  _vm.value >= 0 ? _vm.$emit("input:validated") : null
                },
                focus: function ($event) {
                  _vm.inputHasFocus = true
                },
                blur: function ($event) {
                  _vm.inputHasFocus = false
                },
              },
            }),
          ]),
          _c(
            "p",
            {
              staticClass: "errorMsg text-small mg mg--t-1",
              class: { errorVisible: _vm.$v.value.$error },
            },
            [_vm._v(_vm._s(_vm.$t("claim.details.errorMsgInputTxt")))]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }